(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8995],{

/***/ 77055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49667);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);





var MyModal = function(param) {
    var visible = param.visible, onOk = param.onOk;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "jsx-a6fac5d037a2b763",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Modal */ .u_, {
                visible: visible,
                // onOk={onOk as any}
                onCancel: onOk,
                centered: true,
                hasCancel: true,
                // closable={false}
                bodyStyle: {
                    overflow: "auto"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "https://img.cbcechina.com/2024-12-10/55680c07f06418fb99396fbc289442e3.png",
                    alt: "",
                    className: "jsx-a6fac5d037a2b763"
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "a6fac5d037a2b763",
                children: ".semi-form-field-label-text,.semi-input-number-size-default{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;-moz-box-orient:horizontal;-moz-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;-webkit-box-pack:left;-webkit-justify-content:left;-moz-box-pack:left;-ms-flex-pack:left;justify-content:left;line-height:40px}.semi-input-wrapper{background:white!important;border:none}.semi-modal-footer{text-align:center;margin:0 0 24px}.semi-modal-footer .semi-button{display:none}.semi-modal-close{position:absolute;top:93%;color:white!important;right:50%;background-color:rgb(255,255,255,.4)!important;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%}.semi-modal-content{background-color:transparent!important;border:none!important;-webkit-box-shadow:none!important;-moz-box-shadow:none!important;box-shadow:none!important}.semi-modal-small{width:348px}@media screen and (min-width:1e3px){.semi-modal-small{-webkit-transform:scale(1.3);-moz-transform:scale(1.3);-ms-transform:scale(1.3);-o-transform:scale(1.3);transform:scale(1.3)}}"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MyModal);


/***/ }),

/***/ 41520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ PageLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10797);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(55124);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49667);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62010);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77055);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2261);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25194);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(18700);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94375);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_11__);
















var PageLayout = function(param) {
    var children = param.children, _type = param.type, type = _type === void 0 ? "default" : _type, _isCrumb = param.isCrumb, isCrumb = _isCrumb === void 0 ? true : _isCrumb, _crumb = param.crumb, crumb = _crumb === void 0 ? [] : _crumb, newsPath = param.newsPath;
    var ref, ref1;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_stores__WEBPACK_IMPORTED_MODULE_4__/* .IndexContext */ .Z), nav = ref2.nav, lang = ref2.lang;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), menu = ref3[0], setMenu = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), active = ref4[0], setActive = ref4[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), visible = ref5[0], setVisible = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isHidden = ref6[0], setIsHidden = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isSearch = ref7[0], setIsSearch = ref7[1];
    var bgStyle = {
        "online": {
            bgColor: "#fafafa",
            bgImage: "/image/page-banner2.png"
        },
        "detail": {
            bgColor: "#fafafa",
            bgImage: "/image/page-banner3.png"
        },
        "default": {
            bgColor: "white",
            bgImage: "/image/page-banner.png"
        }
    };
    var navTo = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(e, item) {
        if (router.asPath == item.path) {
            return;
        }
        e.stopPropagation();
        // if (item.path === '/audience/register') {
        //   setVisible(true)
        //   return
        // }
        if (item.outlink) {
            var a = document.createElement("a");
            a.href = "".concat(item.outlink);
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            return;
        }
        router.push(item.path, item.path, {
            shallow: true
        });
    }, [
        active,
        nav
    ]);
    var searchNode = function(data, path) {
        for(var i = 0; i < (data === null || data === void 0 ? void 0 : data.length); i++){
            var item = data[i];
            if (item.path === path) {
                return item;
            }
            if (item.children && Array.isArray(item.children)) {
                var found = searchNode(item.children, path);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var text = router.query.text;
        setIsSearch(!!text);
    }, [
        router.query
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var act = searchNode(nav, newsPath || router.asPath);
        setActive(act);
        var item = nav === null || nav === void 0 ? void 0 : nav.find(function(item) {
            return item.id === (act === null || act === void 0 ? void 0 : act.parent);
        });
        setMenu(item);
        console.log(act, menu);
    }, [
        nav
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            backgroundColor: bgStyle[type].bgColor
        },
        className: "jsx-c0f5046a3b6e64af" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().page) || ""),
        children: [
            isCrumb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-c0f5046a3b6e64af" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().banner) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: bgStyle[type].bgImage,
                        alt: "",
                        className: "jsx-c0f5046a3b6e64af"
                    }),
                    type === "online" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "jsx-c0f5046a3b6e64af" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().onlineCruTitle) || ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                            className: "jsx-c0f5046a3b6e64af",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "jsx-c0f5046a3b6e64af",
                                    children: (menu === null || menu === void 0 ? void 0 : menu.name) || (active === null || active === void 0 ? void 0 : active.name)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "jsx-c0f5046a3b6e64af" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().shade) || ""),
                                    children: menu === null || menu === void 0 ? void 0 : menu.name
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "jsx-c0f5046a3b6e64af" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().cruTitle) || ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                            className: "jsx-c0f5046a3b6e64af",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "jsx-c0f5046a3b6e64af",
                                    children: (menu === null || menu === void 0 ? void 0 : menu.name) || (active === null || active === void 0 ? void 0 : active.name)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "jsx-c0f5046a3b6e64af" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().shade) || ""),
                                    children: menu === null || menu === void 0 ? void 0 : menu.name
                                })
                            ]
                        })
                    })
                ]
            }),
            isCrumb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    marginTop: "".concat(type === "online" ? "-18%" : "-5%")
                },
                className: "jsx-c0f5046a3b6e64af" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().pageHeader) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-c0f5046a3b6e64af" + " " + (classnames__WEBPACK_IMPORTED_MODULE_6___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().floatBox), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().isHidden), isHidden)) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-c0f5046a3b6e64af" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().list) || ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Popover */ .J2, {
                                        showArrow: true,
                                        style: {
                                            backgroundColor: "#F9B000",
                                            padding: "15px 15px 10px",
                                            width: "230px"
                                        },
                                        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-c0f5046a3b6e64af",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    style: {
                                                        width: "100%"
                                                    },
                                                    src: "/image/help-qrcode.png",
                                                    alt: "",
                                                    className: "jsx-c0f5046a3b6e64af"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    style: {
                                                        fontSize: "14px",
                                                        color: "white",
                                                        textAlign: "center",
                                                        marginTop: "5px"
                                                    },
                                                    className: "jsx-c0f5046a3b6e64af",
                                                    children: "更多资讯，关注CBCE小助手"
                                                })
                                            ]
                                        }),
                                        position: "left",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-c0f5046a3b6e64af" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().wechat) || ""),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "jsx-c0f5046a3b6e64af",
                                                    children: "小助手"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                                    className: "jsx-c0f5046a3b6e64af"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "/exhibition/apply",
                                        target: "_self",
                                        className: "jsx-c0f5046a3b6e64af",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-c0f5046a3b6e64af" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().apply) || ""),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "jsx-c0f5046a3b6e64af",
                                                    children: "我要参展"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                                    className: "jsx-c0f5046a3b6e64af"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "https://cbce2025.gration.cn/?member/register&code=sites",
                                        target: "_blank",
                                        className: "jsx-c0f5046a3b6e64af",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-c0f5046a3b6e64af" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().register) || ""),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "jsx-c0f5046a3b6e64af",
                                                    children: "我要参观"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                                    className: "jsx-c0f5046a3b6e64af"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        onClick: function() {
                                            return window.scrollTo(0, 0);
                                        },
                                        className: "jsx-c0f5046a3b6e64af" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().toTop) || ""),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "jsx-c0f5046a3b6e64af",
                                            children: "顶部"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                onClick: function() {
                                    return setIsHidden(!isHidden);
                                },
                                className: "jsx-c0f5046a3b6e64af" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().btn) || ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                        t: "1723196878237",
                                        class: "icon",
                                        viewBox: "0 0 1024 1024",
                                        version: "1.1",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "p-id": "2672",
                                        className: "jsx-c0f5046a3b6e64af",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M320 0 192 128l384 384-384 384 128 128 512-512L320 0z",
                                            "p-id": "2673",
                                            fill: "#fff",
                                            className: "jsx-c0f5046a3b6e64af"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "jsx-c0f5046a3b6e64af",
                                        children: "隐藏"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-c0f5046a3b6e64af" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().crumb) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/image/home.png",
                                alt: "",
                                className: "jsx-c0f5046a3b6e64af"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Breadcrumb */ .aG, {
                                routes: [
                                    {
                                        path: "/",
                                        name: "首页"
                                    },
                                    {
                                        path: (active === null || active === void 0 ? void 0 : active.path) || (menu === null || menu === void 0 ? void 0 : menu.path) || "",
                                        name: (menu === null || menu === void 0 ? void 0 : menu.name) || "",
                                        isShow: !menu
                                    },
                                    {
                                        path: (active === null || active === void 0 ? void 0 : active.path) || "",
                                        name: (active === null || active === void 0 ? void 0 : active.name) || "",
                                        isShow: !active
                                    }
                                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(crumb)).filter(function(item) {
                                    return !item.isShow;
                                }),
                                onClick: function(item) {
                                    router.push(item.path, item.path, {
                                        shallow: true
                                    });
                                },
                                separator: ">"
                            })
                        ]
                    }),
                    (menu === null || menu === void 0 ? void 0 : menu.children) && menu.children.length > 1 && (menu.children.length == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "jsx-c0f5046a3b6e64af",
                        children: menu === null || menu === void 0 ? void 0 : menu.children[0].name
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "jsx-c0f5046a3b6e64af" + " " + (classnames__WEBPACK_IMPORTED_MODULE_6___default()([
                            (_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().pageNav)
                        ]) || ""),
                        children: menu === null || menu === void 0 ? void 0 : (ref = menu.children) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: function(e) {
                                    return navTo(e, item);
                                },
                                className: "jsx-c0f5046a3b6e64af" + " " + (classnames__WEBPACK_IMPORTED_MODULE_6___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().active), item.id === (active === null || active === void 0 ? void 0 : active.id))) || ""),
                                children: item.name
                            }, item.id);
                        })
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .Swiper */ .tq, {
                        className: classnames__WEBPACK_IMPORTED_MODULE_6___default()([
                            (_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().swiper),
                            "crumb"
                        ]),
                        modules: [],
                        // spaceBetween={30}
                        slidesPerView: "auto",
                        style: {
                            display: "none"
                        },
                        children: [
                            (menu === null || menu === void 0 ? void 0 : menu.children) && menu.children.length > 1 && (menu.children.length == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "jsx-c0f5046a3b6e64af",
                                children: menu === null || menu === void 0 ? void 0 : menu.children[0].name
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "jsx-c0f5046a3b6e64af",
                                children: menu === null || menu === void 0 ? void 0 : (ref1 = menu.children) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                                    var _obj;
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .SwiperSlide */ .o5, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            onClick: function(e) {
                                                return navTo(e, item);
                                            },
                                            className: "jsx-c0f5046a3b6e64af" + " " + (classnames__WEBPACK_IMPORTED_MODULE_6___default()((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().swiperList), true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().active), item.id === (active === null || active === void 0 ? void 0 : active.id)), _obj)) || ""),
                                            children: item.name
                                        })
                                    }, item.id);
                                })
                            })),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .SwiperSlide */ .o5, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-c0f5046a3b6e64af" + " " + (classnames__WEBPACK_IMPORTED_MODULE_6___default()([
                    (_styles_module_scss__WEBPACK_IMPORTED_MODULE_12___default().content),
                    "content"
                ]) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "jsx-c0f5046a3b6e64af",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                width: "100%"
                            },
                            className: "jsx-c0f5046a3b6e64af",
                            children: children
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        visible: visible,
                        onOk: function() {
                            return setVisible(false);
                        }
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "c0f5046a3b6e64af",
                children: ".semi-breadcrumb-item-active span{color:#f08200!important}.semi-breadcrumb-item span{font-weight:500;font-size:16px}.crumb .swiper-slide{width:auto}.semi-image-preview-image-img{max-width:none!important}"
            })
        ]
    });
};


/***/ }),

/***/ 48847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sC": function() { return /* binding */ PRODDOMAIN; },
/* harmony export */   "zE": function() { return /* binding */ PRODFORNTDOMAIN; }
/* harmony export */ });
/* unused harmony exports DEVDOMAIN, getIsMobile, getIsSupportWebp */
var DEVDOMAIN = "http://localhost:3001";
// export const PRODDOMAIN = "http://system.icef.com.cn";
var PRODDOMAIN = "https://system.cbcechina.com";
// export const PRODDOMAIN = "http://cbce.smartinfo.cn";
var PRODFORNTDOMAIN = "https://www.cbcechina.com";
var getIsMobile = function(context) {
    var ref = context.ctx.req || {}, _headers = ref.headers, headers = _headers === void 0 ? {} : _headers;
    return /mobile|android|iphone|ipad|phone/i.test((headers["user-agent"] || "").toLowerCase());
};
var getIsSupportWebp = function(context) {
    var ref;
    var ref1 = context.ctx.req || {}, _headers = ref1.headers, headers = _headers === void 0 ? {} : _headers;
    return (ref = headers.accept) === null || ref === void 0 ? void 0 : ref.includes("image/webp");
};


/***/ }),

/***/ 55124:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__raIZH","floatBox":"styles_floatBox__qp_XT","list":"styles_list__NeSqT","wechat":"styles_wechat__SDIqx","apply":"styles_apply__h1kmu","register":"styles_register__5DgXr","contact":"styles_contact__dyJ_R","toTop":"styles_toTop___gneD","btn":"styles_btn__JTQcV","isHidden":"styles_isHidden__0LD2X","banner":"styles_banner__92BqA","onlineCruTitle":"styles_onlineCruTitle__M2YQH","cruTitle":"styles_cruTitle__WIhgI","shade":"styles_shade__EvU0I","pageHeader":"styles_pageHeader__Kkw7J","active":"styles_active__K0KtI","crumb":"styles_crumb__IAstN","pageNav":"styles_pageNav__UKUc2","content":"styles_content__eWsF4","swiper":"styles_swiper__r2mXM","swiperList":"styles_swiperList__Bj6Lh"};

/***/ })

}]);